var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FullMasterTemplate',[_c('LeftMenu'),_c('div',{staticClass:"sub-content",attrs:{"id":"inner-wrap"}},[_c('div',{staticClass:"sub-content-full-space"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }